import { render } from "./PaneListRemediationTasks.vue?vue&type=template&id=8bf266f0&scoped=true&ts=true"
import script from "./PaneListRemediationTasks.vue?vue&type=script&lang=ts"
export * from "./PaneListRemediationTasks.vue?vue&type=script&lang=ts"

import "./PaneListRemediationTasks.vue?vue&type=style&index=0&id=8bf266f0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf266f0"]])

export default __exports__